// Determine colors based on state
export const getColors = (isActive: boolean, isHovered: boolean, isPressed: boolean) => {
    if (isPressed) {
        return { backgroundColor: '#FFFFFF', iconColor: '#242424', textColor: '#242424' };
    }
    if (isHovered) {
        return { backgroundColor: '#0DF200', iconColor: '#242424', textColor: '#242424' };
    }
    return {
        backgroundColor: 'transparent',
        iconColor: isActive ? '#0DF200' : '#D6D6D6',
        textColor: isActive ? '#FFFFFF' : '#D6D6D6',
    };
};